import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateControlePatrimonioUseCase } from "../../../presentation/useCases/update/update_controle_patrimonio_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * IUpdateControlePatrimonioUseCase
 */

export class UpdateControlePatrimonioUseCase implements IUpdateControlePatrimonioUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateControlePatrimonio(
    idControlePatrimonio: number,
    idMaquinaEquip: number,
    dataEntrega: Date | null,
    dataDevolucao: Date | null,
    observacoes: string | null,
    files: File | null,
  ): Promise<void> {
    await this.repository.updateControlePatrimonio(
      idControlePatrimonio,
      idMaquinaEquip,
      dataEntrega,
      dataDevolucao,
      observacoes,
      files ? await this.getFilename(files) : null,
      files,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }

  private async convertToBase64(file: File | null): Promise<string | null> {
    return await FileUtils.readFileAsBase64(file);
  }
}